import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationRule } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

export const usePatchNotificationRulesMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      notificationRules: Pick<NotificationRule, 'notificationRuleId' | 'status'>[]
    ) => {
      return toast.promise(client.patch(`/notifications/rules`, notificationRules), {
        loading: 'Updating notification rules...',
        success: 'Successfully updated the notification rules.',
        error: (_: unknown) =>
          `Uh oh, there was an error with updating the notification rules.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications', 'rules'] });
    },
  });
};
